import {sx} from './sx'
import {useMedia} from "@hooks/ui/useMedia";
import {AppBar, Drawer, Paper, Stack} from "@mui/material";
import {useTranslation} from "react-i18next";
import {logOut} from "@containers/auth/helpers/helpers";
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import {BurgerIcon, LeftArrowIcon, LogOutIcon} from "@ui/icons/icons";
import Sidebar from "@view/sidebar/Sidebar";
import ToggleThemeMode from "@view/theme/toggleThemeMode/ToggleThemeMode";
import {useActionContext} from "@context/actionContext/hooks/useActionContext";
import Logo from "@view/header/logo/Logo";
import HideOnScroll from "@view/header/hideOnScroll/HideOnScroll";
import ToggleThemeSize from "@view/theme/toggleThemeMode/ToggleThemeSize";
import HideSidebarBtn from "@view/sidebar/hideSidebarBtn/HideSidebarBtn";
import ChatIconButton from "@containers/chat/widget/ChatIconButton";
import AccountColorPicker from "@containers/accountStyle/picker/AccountColorPicker";
import {useAccountStyle} from "@containers/accountStyle/hooks/useAccountStyle";
import AccountSwitcher from "@containers/adminAccounts/switcher/AccountSwitcher";


const Header = () => {

    const {visibleMobileSidebar, setVisibleMobileSidebar,} = useActionContext()
    const {isDesktop} = useMedia()
    const {t} = useTranslation()
    const {tokens} = useAccountStyle()

    const toggleVisibleMobileSidebar = () => {
        setVisibleMobileSidebar((prev) => !prev)
    }
    const onClick = () => {
        isDesktop ? logOut() : toggleVisibleMobileSidebar();
    }

    return (
        <HideOnScroll>
            <AppBar>
                <Paper
                    sx={{...sx.root, background: tokens.headerBackground}}
                >
                    <Stack
                        justifyContent={'space-between'}
                        alignItems={'center'}
                        direction={'row'}
                    >
                        <Stack
                            gap={1}
                            alignItems={'center'}
                            direction={'row'}
                        >
                            <Logo/>

                            {isDesktop && <HideSidebarBtn/>}
                        </Stack>

                        <Stack
                            direction={'row'}
                            sx={sx.inner}
                            gap={'5px'}
                        >
                            <AccountSwitcher/>
                            <ChatIconButton/>

                            <ToggleThemeSize/>

                            <AccountColorPicker/>

                            <ToggleThemeMode/>

                            {/* On mobile the right button opens the menu, so log out gets its own button. */}
                            {!isDesktop && <IconButtonCustom
                                onClick={logOut}
                                variant={'empty'}
                            >
                                <LogOutIcon/>
                            </IconButtonCustom>}

                            <IconButtonCustom
                                onClick={onClick}
                                tooltipProps={{placement: 'left'}}
                                tooltip={isDesktop && t('logOut')}
                                variant={'empty'}
                            >
                                {isDesktop ? <LogOutIcon/> : <BurgerIcon/>}
                            </IconButtonCustom>
                        </Stack>


                    </Stack>

                    {!isDesktop && <Drawer
                        variant="temporary"
                        open={visibleMobileSidebar}
                        onClose={toggleVisibleMobileSidebar}
                        ModalProps={{keepMounted: true}}
                        sx={sx.drawer}
                    >
                        <Stack
                            sx={{...sx.mobile.closeSidebar.root, background: tokens.headerBackground}}
                            direction={'row'}
                            justifyContent={'flex-end'}
                        >
                            <IconButtonCustom
                                sx={sx.mobile.closeSidebar.button}
                                onClick={toggleVisibleMobileSidebar}
                            >
                                <LeftArrowIcon
                                    color={'#fff'}/>
                            </IconButtonCustom>
                        </Stack>
                        <Sidebar/>
                    </Drawer>}

                </Paper>
            </AppBar>
        </HideOnScroll>
    )
};

export default Header;